export default __webpack_public_path__ + "static/media/schermata_di_calcolo.45970ef1.png";